// extracted by mini-css-extract-plugin
export default {"alert":"kc3K5A9_V9Y2H8mvQLWT","align-left":"An6aXS4SOLz898vc1UKF","alertContent":"Nh4rhodanMSpZv6GdLbP","alertIcon":"EbxfyG6XAhGMZCa5RrrU"};